import { useState } from 'react'
import useAnalysis from './useAnalysis'
import { QuestionRoutes } from 'types'

const useRoute = () => {
  const { answerHistory } = useAnalysis()

  const [routes, setRoutes] = useState<QuestionRoutes>({
    yes: {
      index: 1000,
    },
    no: {
      index: 1000,
    },
  })

  return {
    answerHistory,
    routes,
    setRoutes,
  }
}

export default useRoute
